import React from 'react';
import Unauthorized from '../../components/common/Unauthorized';
export const Authorization = (User, WrappedComponent, Scope, Value, IsPage) => {
    return class WithAuthorization extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                IsEnabled: false
            };

            if (User != null) {

                var roles = User.roles;
                var modules = User.modules;

                //Scope = User
                if (Scope === "User" &&
                    (roles != null && roles.length > 0) &&
                    (roles.includes("Data Approver") || roles.includes("Division Manager") || roles.includes("Compiler") || roles.includes("Administrator"))) {
                    this.state = {
                        IsEnabled: true
                    };
                }

                //Scope = Global
                if (Scope === "Global" &&
                    ((roles != null && roles.length > 0))) {
                    this.state = {
                        IsEnabled: true
                    };
                }

                //Scope = Module
                if (Scope === "Module" && modules != null && modules.length > 0 && modules.includes(Value)) {
                    this.state = {
                        IsEnabled: true
                    };
                }

                //Scope = Role
                if (Scope === "Role" && roles != null && roles.length > 0 && roles.includes(Value)) {
                    this.state = {
                        IsEnabled: true
                    };
                }

                //RITM1236093
                //Scope = UserList
                if (Scope === "UserList" && roles != null && roles.length > 0 && User.amUsertype) {
                    this.state = {
                        IsEnabled: true
                    };
                }
                //End

            }


        }
        render() {
            if (this.state.IsEnabled != null && this.state.IsEnabled) {
                return (<WrappedComponent {...this.props}></WrappedComponent>);
            } else {
                const content = IsPage ? <Unauthorized /> : null;
                return (content);
            }
        }
    }
}
